import { useEffect, useState } from "react";

import { storageGet, storageSet, storageKeys } from "@/utils/storage";

export function initTheme() {
  const stored = storageGet(storageKeys.theme, "color-theme");
  const prefersDark = window.matchMedia(
    "(prefers-color-scheme: dark)"
  ).matches;
  const dark = stored ? stored === "dark" : prefersDark;
  document.documentElement.classList.toggle("dark", dark);
}

export function useTheme() {
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    // Track external changes (e.g. another toggle instance, screenshot harness)
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const toggle = () => {
    const next = !isDark;
    document.documentElement.classList.toggle("dark", next);
    storageSet(storageKeys.theme, next ? "dark" : "light");
    setIsDark(next);
  };

  return { isDark, toggle };
}
